import React from 'react'

export default function UnimportantText({text, color}) {
    return (
    <span style={{opacity: 0.6, fontStyle: 'italic', color: color ? color : '#000'}}>{text}</span>
    )
}
